import {
  Component,
  computed,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { CorporateDesignStore } from '../../../services/api/corporate-design/corporate-design-store.service';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { EEntityType, ERelationType } from '@web/dtos';
import { EOrderHistoryAction } from '../../../pages/shop/account/account-orders-page/account-orders-page.component';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { HoverHighlight } from '../../../directives/hover-highlight';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { NgClass, NgStyle } from '@angular/common';

interface IOrderHistoryItem {
  icon: string;
  translationKey?: ERelationType;
  label?: string;
  action: EOrderHistoryAction;
  isHidden?: boolean;
}

@Component({
  selector: 'aw-order-history-sub-menu',
  imports: [FilterTextsPipe, HoverHighlight, LanguagePipe, NgClass, NgStyle],
  templateUrl: './order-history-sub-menu.component.html',
  standalone: true,
})
export class OrderHistorySubMenuComponent {
  public readonly darkModeBorderColor: InputSignal<string> =
    input<string>('#FFFFFF');

  public readonly onSubmenuClick: OutputEmitterRef<EOrderHistoryAction> =
    output();
  public readonly showResend: InputSignal<boolean> = input(true);
  public readonly showDownload: InputSignal<boolean> = input(true);

  protected readonly corporateDesignStore: CorporateDesignStore =
    inject(CorporateDesignStore);
  protected readonly corporateDesign: CorporateDesignService = inject(
    CorporateDesignService
  );

  protected readonly textStore: WebTextStore = inject(WebTextStore);

  protected readonly highlightedItem: WritableSignal<number | undefined> =
    signal(undefined);
  protected readonly isDarkMode: Signal<boolean> =
    this.corporateDesign.isDarkModeActive;
  public readonly darkModeColor: string =
    this.corporateDesignStore.corporateDesign().colorAdmixtures.dark_surface_01;

  protected readonly subMenuItems: Signal<IOrderHistoryItem[]> = computed(
    () => {
      const items: IOrderHistoryItem[] = [];
      if (this.showResend()) {
        items.push({
          icon: 'mail',
          translationKey: ERelationType.orderHistoryResend,
          action: EOrderHistoryAction.resend,
        });
      }
      if (this.showDownload()) {
        items.push({
          icon: 'download',
          translationKey: ERelationType.orderHistoryDownload,
          action: EOrderHistoryAction.download,
        });
      }
      return items;
    }
  );

  public setHighlightedItem(isHovered: boolean, index: number): void {
    if (isHovered) {
      this.highlightedItem.set(index);
    }
  }

  protected readonly EEntityType = EEntityType;
  protected readonly ERelationType = ERelationType;
}
